/**
 * PurchaseOrder schemalari (Phase 4) — taminotchiga rasmiy buyurtma.
 *
 * Hayot davri:
 *   DRAFT → SENT → IN_TRANSIT → PARTIAL/RECEIVED
 *   yoki har bosqichda CANCELLED
 *
 * Qabul qilish (receive) — har item uchun necha dona kelganini yozadi va
 * StockMovement(IN) yaratadi. Stock avtomat oshadi.
 */
import { z } from 'zod';
import { uuidSchema } from './common.schema.js';
import { currencyEnum } from './product.schema.js';
export const purchaseOrderStatusEnum = z.enum([
    'DRAFT',
    'SENT',
    'IN_TRANSIT',
    'PARTIAL',
    'RECEIVED',
    'CANCELLED',
]);
export const purchaseOrderItemSchema = z.object({
    productId: uuidSchema,
    variantSku: z.string().min(1).max(50).optional(),
    productName: z.string().min(1).max(300),
    productSku: z.string().max(50).optional(),
    orderedQty: z.coerce.number().int().min(1).max(100_000),
    unitCost: z.coerce.number().min(0),
    currency: currencyEnum,
});
export const createPurchaseOrderSchema = z.object({
    supplierId: uuidSchema,
    expectedAt: z.string().datetime().optional(),
    note: z.string().max(1000).optional(),
    items: z.array(purchaseOrderItemSchema).min(1).max(500),
});
export const updatePurchaseOrderStatusSchema = z.object({
    status: z.enum(['SENT', 'IN_TRANSIT', 'CANCELLED']),
});
export const receivePurchaseOrderItemSchema = z.object({
    itemId: uuidSchema,
    /** Bu qabul partiyasida necha dona keldi (jami emas) */
    receivedNow: z.coerce.number().int().min(0).max(100_000),
});
export const receivePurchaseOrderSchema = z.object({
    items: z.array(receivePurchaseOrderItemSchema).min(1).max(500),
    note: z.string().max(500).optional(),
});
export const listPurchaseOrdersSchema = z.object({
    supplierId: uuidSchema.optional(),
    status: purchaseOrderStatusEnum.optional(),
    dateFrom: z.string().datetime().optional(),
    dateTo: z.string().datetime().optional(),
    limit: z.coerce.number().int().min(1).max(500).default(50),
    cursor: z.string().max(200).optional(),
});
//# sourceMappingURL=purchase-order.schema.js.map